import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

export const DeleteVisualDialog = ({ visual, isActive, closeDialog }) => {
    const {
        dashboardLib,
    } = useDashboardDomainContext();

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            title={"Delete Visual"}
            onOk={() => {
                closeDialog();
                dashboardLib.deleteVisual(visual);
            }}
            onCancel={() => {
                closeDialog();
            }}
            okText={"Delete"}
        >
            <div className="dialog-text">
                Please confirm that you want to delete this visual.
            </div>
        </DialogControl>
    )
}
